import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors, FormArray, AbstractControl } from '@angular/forms';
import { ProfileSurvey } from '../../../class/profile-survey';
// import { ProfileSurveyNewField } from '../../../class/profile-survey-new-field';
// import { ProfileSurveyDimensionsComponent } from './profile-survey-dimensions/profile-survey-dimensions/profile-survey-dimensions.component';
import { ProfileSurveyService } from '../../../service/profile-survey/profile-survey.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, Message } from 'primeng/primeng';
import { CustomerGuide } from '../../../class/customer-guide';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { UploadFilesService } from '../../../service/upload-files/upload-files.service';
import { config } from '../../../../../../environments/config';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
// import { NUMBER_TYPE } from '@angular/compiler/src/output/output_ast';
import { formatDate } from '../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { ControlRequiredPipe } from '../../../pipe/controlRequired/controlRequired.pipe';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { ProfileEducationLevelOptions } from '../../../../../shared/constans';
import { MedicalExamsService } from '../../../service/medical-exams/medical-exams.service';

@Component({
    selector: 'app-new-profile-survey',
    templateUrl: './new-profile-survey.component.html',
    styleUrls: ['./new-profile-survey.component.scss']
})

export class NewProfileSurveyComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: ProfileSurvey;
    @Input() idCustomerGuide: string;
    @Input() embeddedMode: boolean = false;
    // @Input() customerGuide: CustomerGuide;
    // public idCustomerGuide: string; // @Input()
    public promiseForm: Promise<any>;
    public formProfileSurvey: FormGroup;
    public profile_survey: string;
    public customerGuideId: number;



    public profileSurveyLevelOptions: any[];
    public dimensionsOptions: any[];
    public uploadedFileProfileSurvey: any[] = [];
    public prewiewFileProfileSurvey: any;
    public promiseFileProfileSurvey: Promise<any>;
    public apiUrl = config.API_ROOT;
    public msgs: Message[];


    public processTypeOptions: SelectItem[];
    public genderOptions: SelectItem[];

    public es: any;

    public optionsSelectionCompetence: any[];
    public optionsSelectionCompetenceSl: any[];

    public customerGuides: CustomerGuide[];
    public closeWindow: boolean = false;

    public changedProfileSurvey: boolean = true;

    public dimensions: any[];

    // public medicalExamOptions: any[] = [
    //     { id: 1, name: 'Administrative', value: 'Administrativo' },
    //     { id: 8, name: 'Operational', value: 'Operativa' },
    //     { id: 3, name: 'Commercial', value: 'Comercial' },
    //     { id: 4, name: 'Financial', value: 'Financiera' }
    // ];
    public medicalExamOptions: any[] = [];
    selectedExamsFromBackend = [3, 4];


    private id: number;
    public showPage: number = 0;

    public experienceAreaOptions: any[];
    public experienceSectorOptions: any[];
    public minimuEducationOptions: any[] = ProfileEducationLevelOptions;
    public userRole: any;
    public rolesChangeEstimatedTimeRequisition: any[];
    public workModeOptions: any[];
    public salaryModeOptions: any[];
    public salaryPaymentModeOptions: any[];
    public ARLRiskOptions: any[];
    public workdayScheduleOptions: any[];
    public commissionsOptions: any[];


    constructor(
        public fb: FormBuilder,
        public companyService: ProfileSurveyService,
        public translate: TranslateService,
        public profileSurveyService: ProfileSurveyService,
        public activatedRoute: ActivatedRoute,
        public uploadFilesService: UploadFilesService,
        public customerGuideService: CustomerGuideService,
        public router: Router,
        public hasPermissionService: HasPermissionService,
        private ngZone: NgZone,
        private controlRequiredPipe: ControlRequiredPipe,
        private notificationsService: NotificationsService,
        private medicalExamsService: MedicalExamsService

    ) {
        this.initializeOptions();
        this.es = calendarES();
    }

    ngOnInit() {
        if (this.edit && this.edit.id) {
            this.customerGuideId = this.edit.customer_guide_id;
            this.createForm(this.edit);
            this.showPage = 1;
            return;
        }

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_customer_guide'])
                this.idCustomerGuide = params['id_customer_guide'];

            // if (params['profile_survey']) {
            //     this.profile_survey = params['profile_survey'];
            //     // console.log("muestra el profile survey");
            //     this.closeWindow=true;
            // }
        });

        this.id = +this.activatedRoute.snapshot.paramMap.get('profile_survey_id');
        if (this.id !== 0 && (this.id !== undefined)) {
            var promiseLoc = this.profileSurveyService.infoProfileSurvey(this.id).toPromise().then(
                response => {
                    this.edit = response.json();
                    this.customerGuideId = this.edit.customer_guide_id;
                    this.createForm(this.edit);
                    this.showPage = 1;
                },
                error => {
                    this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
                    this.router.navigateByUrl('/pages/selection/profile-surveis');

                }
            );
        } else {

            this.customerGuideId = parseInt(this.idCustomerGuide);
            this.createForm();
            this.showPage = 1;
        }
    }

    createForm(data: any = null) {

        // Estructura por defecto para profile_survey_new_field
        var defaultProfileSurveyNewField = {
            process_name: '',
            process_type: '',
            authority_on: '',
            authority_to: '',
            equivalences: '',
            document_city: '',
            reviewed_by_id: '',
            elaborated_by_id: '',
            approved_by_id: '',
            received_by_id: '',
            approval_date: null,
            education_level: '',
            competence_effective_communication: '',
            competence_selfmanagement: '',
            competence_service_attitude: '',
            competences: [],
            responsabilities: []
        };

        // VERSIÓN ANGULAR 2: Sin spread operator, usar Object.assign
        var baseData: any = {
            customer_guide_id: this.customerGuideId,
            employee_position: '',
            range_age_min: '',
            range_age_max: '',
            position_functions: '',
            gender: '',
            salary: '',
            salary_conditions: '',
            profile_survey_level: (this.customerGuideId == 5) ? 'Administrativo' : '',
            risk: '',
            schedule: '',
            restriction: '',
            restriction_description: '',
            additional_information: '',
            approved: '0',
            minimum_education: 0,
            education_observation: '',
            education_additional: '',
            experience_required: null,
            experience_required_time: '',
            experience_area: '',
            experience_sector: '',
            profesional_experience: '',
            profesional_additional: '',
            psychotechnical_tests: '',
            knowledge_tests: '',
            form_company: '',
            test_apply: '',
            test_apply_description: '',
            physical_load: '',
            initial_observation: '',
            activated: true,
            estimated_time_requisition: '15',
            competence_teamwork: '',
            competence_integrity: '',
            competence_assertive_communication: '',
            competence_customer_orientation: '',
            competence_negotiation: '',
            competence_responsability: '',
            competence_adaptation_to_change: '',
            competence_compromise: '',
            competence_result_orientation: '',
            competence_continuous_learning: '',
            competence_relationship_management: '',
            competence_flexibility: '',
            competence_tolerance: '',
            competence_problems_resolution: '',
            work_mode: '',
            salary_mode: '',
            salary_payment_method: '',
            workday_schedule: '',
            workday_detail: '',
            commissions: '',
            medicalExams: [],
            show_crm: false
        };

        // Agregar profile_survey_new_field si es customerGuideId == 5
        if (this.customerGuideId == 5) {
            // Merge de datos legacy con defaults usando Object.assign
            var existingProfileData = (data && data.profile_survey_new_field) ? data.profile_survey_new_field : {};
            baseData.profile_survey_new_field = Object.assign({}, defaultProfileSurveyNewField, existingProfileData);
        }

        // Si no hay data, usar baseData
        data = data || baseData;

        if (data.risk !== null && data.risk !== undefined && data.risk !== '') {
            data.risk = Number(String(data.risk).replace(',', '.'));
        }

        // ÚNICA VERIFICACIÓN NECESARIA: Para customerGuideId == 5
        if (this.customerGuideId == 5) {
            // Si no existe profile_survey_new_field O si existe pero está incompleto
            if (!data.profile_survey_new_field) {
                // No existe (datos muy antiguos)
                data.profile_survey_new_field = Object.assign({}, defaultProfileSurveyNewField);
            }
        }

        this.formProfileSurvey = this.fb.group({
            customer_guide_id: [data.customer_guide_id],
            employee_position: [data.employee_position, Validators.compose([Validators.required, Validators.minLength(5)])],
            range_age_min: [data.range_age_min, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('^[0-9]*$')])],
            range_age_max: [data.range_age_max, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.maxLength(2), Validators.pattern('^[0-9]*$')])],

            position_functions: [data.position_functions, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1)])],
            // 'access_modules': [data.'access_modules'],
            gender: [data.gender, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1),])],
            salary: [data.salary, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(5), Validators.pattern('^[0-9.,]*$')])],
            salary_conditions: [data.salary_conditions, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(300)])],
            profile_survey_level: [data.profile_survey_level, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1)])],
            risk: [data.risk, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            schedule: [data.schedule, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(5)])],
            work_mode: [data.work_mode, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            salary_mode: [data.salary_mode, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            salary_payment_method: [data.salary_payment_method, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            workday_schedule: [data.workday_schedule, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            workday_detail: [data.workday_detail],
            commissions: [data.commissions, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            restriction: [data.restriction],
            restriction_description: [data.restriction_description, (this.customerGuideId == 5) ? Validators.compose([Validators.required, Validators.minLength(1)]) : []],   // En esta vista se llama objetivo,
            additional_information: [data.additional_information],
            approved: [(data.approved == '1') ? true : false],
            minimum_education: [data.minimum_education, Validators.compose([Validators.required])],
            education_observation: [data.education_observation],
            education_additional: [data.education_additional],
            experience_required: [data.experience_required, Validators.compose([Validators.required])],
            experience_required_time: [data.experience_required_time],
            experience_sector: [data.experience_sector, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1)])],
            profesional_experience: [data.profesional_experience, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required])],
            profesional_additional: [data.profesional_additional],
            changed_by_id: [JSON.parse(localStorage.getItem('profile')).employee_id],

            experience_area: [data.experience_area, (this.customerGuideId == 5) ? [] : Validators.compose([Validators.required, Validators.minLength(1)])],
            psychotechnical_tests: [data.psychotechnical_tests],
            knowledge_tests: [data.knowledge_tests],
            form_company: [data.form_company],
            test_apply: [data.test_apply],
            test_apply_description: [data.test_apply_description],
            physical_load: [data.physical_load],
            initial_observation: [data.initial_observation],
            activated: [data.activated],
            estimated_time_requisition: [{ value: data.estimated_time_requisition, disabled: !this.rolesChangeEstimatedTimeRequisition.includes(this.getRoleId()) },
            (this.customerGuideId == 5 || this.rolesChangeEstimatedTimeRequisition.includes(this.getRoleId)) ? [] : Validators.compose([Validators.required, Validators.min(1)])],
            competence_integrity: [data.competence_integrity],
            competence_teamwork: [data.competence_teamwork],
            competence_assertive_communication: [data.competence_assertive_communication],
            competence_customer_orientation: [data.competence_customer_orientation],

            competence_negotiation: [data.competence_negotiation],
            competence_responsability: [data.competence_responsability],
            competence_adaptation_to_change: [data.competence_adaptation_to_change],
            competence_compromise: [data.competence_compromise],
            competence_result_orientation: [data.competence_result_orientation],
            competence_continuous_learning: [data.competence_continuous_learning],
            competence_relationship_management: [data.competence_relationship_management],
            competence_flexibility: [data.competence_flexibility],
            competence_tolerance: [data.competence_tolerance],
            competence_problems_resolution: [data.competence_problems_resolution],
            medicalExams: [data.medicalExams],
            show_crm: [data.show_crm ? true : false],
        });



        if (this.customerGuideId == 5) {

            const profileSurveyNewFieldGroup = this.fb.group({
                process_name: [data.profile_survey_new_field.process_name, Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(255)])],
                process_type: [data.profile_survey_new_field.process_type, Validators.compose([Validators.required, Validators.minLength(1)])],
                authority_on: [data.profile_survey_new_field.authority_on, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(255)])],
                authority_to: [data.profile_survey_new_field.authority_to, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(255)])],
                equivalences: [data.profile_survey_new_field.equivalences, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(255)])],
                document_city: [data.profile_survey_new_field.document_city, Validators.compose([Validators.required, Validators.minLength(2)])],
                reviewed_by_id: [data.profile_survey_new_field.reviewed_by_id, Validators.compose([Validators.required])],
                elaborated_by_id: [data.profile_survey_new_field.elaborated_by_id, Validators.compose([Validators.required])],
                approved_by_id: [data.profile_survey_new_field.approved_by_id, Validators.compose([Validators.required])],
                received_by_id: [data.profile_survey_new_field.received_by_id],
                approval_date: [data.profile_survey_new_field.approval_date ? new Date(data.profile_survey_new_field.approval_date) : null, Validators.compose([Validators.required])],

                competence_effective_communication: [data.profile_survey_new_field.competence_effective_communication],
                competence_service_attitude: [data.profile_survey_new_field.competence_service_attitude],

                competences: this.initFormArrayCompetences(data.profile_survey_new_field.competences),
                responsabilities: this.initFormArrayResponsabilities(data.profile_survey_new_field.responsabilities),
            });

            this.formProfileSurvey.addControl('profile_survey_new_field', profileSurveyNewFieldGroup);

        }

        const workdayScheduleControl = this.formProfileSurvey.get('workday_schedule');
        if (workdayScheduleControl) {
            this.updateWorkdayDetailValidator(workdayScheduleControl.value);
            workdayScheduleControl.valueChanges.subscribe(value => {
                this.updateWorkdayDetailValidator(value);
            });
        }

        this.loadExams();
        if (this.edit && this.edit.file_profile_survey) {
            this.uploadedFileProfileSurvey = [];
            this.uploadedFileProfileSurvey.push({ 'name': 'Archivo Adjunto  ' });
        }
    }

    public cancelProfileSurvey() {
        this.formProfileSurvey.reset();
        this.close.emit(true);
        if (this.closeWindow) {
            window.close();
            this.router.navigate(['/pages/selection/profile-surveis']);
        }
    }

    public newProfileSurvey() {

        this.formProfileSurvey.get('estimated_time_requisition').enable();
        var values = this.formProfileSurvey.value;
        values.salary = values.salary == '' || values.salary == null ? null : values.salary.replace(/[\.,]/g, '');
        if (values.profile_survey_new_field) {
            this.assignValue(values.profile_survey_new_field, 'elaborated_by_id', this.getValueById);
            this.assignValue(values.profile_survey_new_field, 'reviewed_by_id', this.getValueById);
            this.assignValue(values.profile_survey_new_field, 'approved_by_id', this.getValueById);
            this.assignValue(values.profile_survey_new_field, 'received_by_id', this.getValueById);
            values.profile_survey_new_field.approval_date = values.profile_survey_new_field.approval_date ? formatDate(values.profile_survey_new_field.approval_date) : null;
        }

        const canSubmit = this.embeddedMode ? true : this.formProfileSurvey.valid;

        if (values && canSubmit) {
            const promise = (this.edit) ?
                this.companyService.updateProfileSurvey(this.edit.id, values)
                :
                this.companyService.newProfileSurvey(values);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        this.msg.emit({ severity: 'success', summary: res });
                        this.formProfileSurvey.reset();
                        if (this.closeWindow)
                            window.close();

                        if (this.embeddedMode) {
                            this.close.emit(true);
                            return;
                        }

                        this.router.navigate(['/pages/selection/profile-surveis']);
                    });
                },
                error => {
                    this.formProfileSurvey.get('estimated_time_requisition').disable();
                    this.msg.emit({ severity: 'error', summary: 'Error' });
                }
            );
        }
    }

    getValueById(var_by_id: any): any {
        var ret_id = undefined;
        if (var_by_id) {
            if (var_by_id.id)
                ret_id = var_by_id.id;
            else
                ret_id = var_by_id;
        }
        return ret_id;
    }

    public assignValue(values, property, getValueFn) {
        if (values.hasOwnProperty(property)) {
            values[property] = getValueFn(values[property]);
        }
    }

    // getFormValidationErrors(form) {
    //     let value = '';
    //     Object.keys(form.controls).forEach(key => {
    //         const controlErrors: ValidationErrors = form.get(key).errors;
    //         if (controlErrors != null) {
    //             Object.keys(controlErrors).forEach(keyError => {
    //                 value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
    //             });
    //         }
    //     });
    //     return (value);
    // }

    public onUploadFileProfileSurvey(event: any) {
        this.uploadedFileProfileSurvey = [];
        for (const file of event.srcElement.files) {
            this.uploadedFileProfileSurvey.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
                this.prewiewFileProfileSurvey = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateFileProfileSurvey(event: any) {
        this.uploadedFileProfileSurvey = [];
        for (const file of event.files) {
            this.uploadedFileProfileSurvey.push(file);
        }

        this.promiseFileProfileSurvey = this.uploadFilesService.updateFileProfileSurvey(this.uploadedFileProfileSurvey, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: res });
                });
                // this.getProfile();
                // this.avatar = this.prewiewFileProfileSurvey;
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: errorMsg });
            }
        );
    }

    public gotoFileProfileSurvey() {
        window.open(this.apiUrl + '/profile-surveis/' + this.edit.id + '/file-profile-survey' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    // public downloadFileProfileSurvey() {
    //     this.promiseFileProfileSurvey = this.uploadFilesService.getFileProfileSurvey(this.edit.id).toPromise().then(
    //         response => {
    //         },
    //         error => {
    //             let errorMsg = '';
    //             errorMsg = 'Error';
    //             this.msgs = [];
    //             this.msgs.push( { severity: 'error', summary: errorMsg  } );
    //         }
    //     );
    // }
    public changesProfileSurvey(change) {
        // this.edit.changed = change;
        this.changedProfileSurvey = change;
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public minimum_salary() {
        this.formProfileSurvey.get('salary').setValue("1750905");
    }

    public getStatus(event, name: string) {
        // console.log("El pinche rol es: " + event)
        var status = false;
        if (event == name)
            status = true;
        // this.previousStatusCompetence = event;
        // this.activateStringStateControl(event);
        return status;
    }

    public activateControl(state: boolean, control_name: string) {
        if (state)
            this.formProfileSurvey.get(control_name).setValidators([Validators.required]);
        else
            this.formProfileSurvey.get(control_name).setValidators([]);

        this.formProfileSurvey.controls[control_name].updateValueAndValidity();
    }

    public confControl(control_name: string, validatorsLoc: boolean) {
        if (validatorsLoc)
            this.formProfileSurvey.get(control_name).setValidators([Validators.required, Validators.minLength(3)]);
        else {
            this.formProfileSurvey.get(control_name).setValue('');
            this.formProfileSurvey.get(control_name).setValidators([]);
        }

        this.formProfileSurvey.controls[control_name].updateValueAndValidity();
    }

    public onWorkdayScheduleChange(value: string) {
        this.updateWorkdayDetailValidator(value);
    }

    private updateWorkdayDetailValidator(workdayScheduleValue: string) {
        const workdayDetailControl = this.formProfileSurvey.get('workday_detail');
        if (!workdayDetailControl) return;

        if (workdayScheduleValue === 'Especial') {
            workdayDetailControl.setValidators([Validators.required, Validators.minLength(1)]);
        } else {
            workdayDetailControl.clearValidators();
            workdayDetailControl.setValue('');
        }

        workdayDetailControl.updateValueAndValidity({ emitEvent: false });
    }

    public activateStringStateControl(state) {
        let validator = true;
        if (state == 'Administrativo') {
            this.validatorsIdleCompetence();
            this.confControl('competence_integrity', validator);
            this.confControl('competence_compromise', validator);
            this.confControl('competence_tolerance', validator);
            this.confControl('competence_responsability', validator);
        } else if (state == 'Comercial') {
            this.validatorsIdleCompetence();
            this.confControl('competence_assertive_communication', validator);
            this.confControl('competence_relationship_management', validator);
            this.confControl('competence_negotiation', validator);
            this.confControl('competence_customer_orientation', validator);
        } else if (state == 'Estratégico') {
            this.validatorsIdleCompetence();
            this.confControl('competence_integrity', validator);
            this.confControl('competence_negotiation', validator);
            this.confControl('competence_result_orientation', validator);
            this.confControl('competence_teamwork', validator);
        } else if (state == 'Operativo') {
            this.validatorsIdleCompetence();
            this.confControl('competence_adaptation_to_change', validator);
            this.confControl('competence_teamwork', validator);
            this.confControl('competence_compromise', validator);
            this.confControl('competence_continuous_learning', validator);
        } else if (state == 'Técnico') {
            this.validatorsIdleCompetence();
            this.confControl('competence_flexibility', validator);
            this.confControl('competence_integrity', validator);
            this.confControl('competence_result_orientation', validator);
            this.confControl('competence_problems_resolution', validator);
        } else {
            this.validatorsIdleCompetence();
        }
        // this.formProfileSurvey.controls[control_name].updateValueAndValidity();
    }
    public validatorsIdleCompetence() {
        let validator = false;
        this.confControl('competence_integrity', validator);
        this.confControl('competence_compromise', validator);
        this.confControl('competence_tolerance', validator);
        this.confControl('competence_responsability', validator);
        this.confControl('competence_assertive_communication', validator);
        this.confControl('competence_relationship_management', validator);
        this.confControl('competence_negotiation', validator);
        this.confControl('competence_customer_orientation', validator);
        this.confControl('competence_result_orientation', validator);
        this.confControl('competence_teamwork', validator);
        this.confControl('competence_adaptation_to_change', validator);
        this.confControl('competence_continuous_learning', validator);
        this.confControl('competence_flexibility', validator);
        this.confControl('competence_problems_resolution', validator);
    }

    // Obtiene el control del FormArray anidado
    getCompetenceControl(index: number, controlName: string): FormControl {
        return this.getCompetencesArray().at(index).get(controlName) as FormControl;
    }

    // Obtiene el FormArray completo
    getCompetencesArray(): FormArray {
        // Ajusta la ruta según tu estructura específica
        return this.formProfileSurvey.get('profile_survey_new_field.competences') as FormArray;
    }

    // Obtiene los índices para la iteración
    getCompetencesIndex(): number[] {
        return this.getCompetencesArray().controls.map((_, i) => i);
    }

    getControl(path: string): AbstractControl {
        return this.formProfileSurvey.get(path);
    }

    get competences() {
        // return this.formProfileSurvey.controls["competences"] as FormArray;
        return this.formProfileSurvey.get('profile_survey_new_field.competences') as FormArray;
    }

    addCompetence(data: any = null) {
        this.competences.push(this.createCompetence(data));
        return;
    }
    createCompetence(data: any = null) {
        data = data || {
            id: undefined,
            ps_competences: '',
            ps_competences_sl: '',
        };
        const competencesForm = this.fb.group({
            id: new FormControl(data.id),
            ps_competences: new FormControl(data.ps_competences, Validators.compose(null)),
            ps_competences_sl: new FormControl(data.ps_competences_sl, Validators.compose(null)),
        });

        return competencesForm;

    }

    deleteCompetence(newCompetenceIndex: number) {
        this.competences.removeAt(newCompetenceIndex);
    }

    getResponsabilityControl(index: number, controlName: string): FormControl {
        return this.getResponsabilitiesArray().at(index).get(controlName) as FormControl;
    }

    // Obtiene el FormArray completo de responsabilidades
    getResponsabilitiesArray(): FormArray {
        // Ajusta la ruta según tu estructura específica
        return this.formProfileSurvey.get('profile_survey_new_field.responsabilities') as FormArray;
    }

    // Obtiene los índices para la iteración
    getResponsabilitiesIndex(): number[] {
        return this.getResponsabilitiesArray().controls.map((_, i) => i);
    }

    get responsabilities() {
        // return this.formProfileSurvey.controls["responsabilities"] as FormArray;
        return this.formProfileSurvey.get('profile_survey_new_field.responsabilities') as FormArray;
    }

    addResponsability(data: any = null) {
        this.responsabilities.push(this.createResponsability(data));
        return;
    }
    createResponsability(data: any = null) {
        data = data || {
            id: undefined,
            dimension: '',
            responsability_name: '',
        };
        const responsabilitiesForm = this.fb.group({
            id: new FormControl(data.id),
            dimension: new FormControl(data.dimension, Validators.compose([Validators.required])),
            responsability_name: new FormControl(data.responsability_name, Validators.compose([Validators.required])),
        });

        return responsabilitiesForm;

    }

    deleteResponsability(newResponsabilityIndex: number) {
        this.responsabilities.removeAt(newResponsabilityIndex);
    }

    initFormArrayCompetences(dataBackend: any[]) {
        const itemsArray = this.fb.array([]);

        dataBackend.forEach(item => {
            itemsArray.push(this.createCompetence(item));
        });

        return itemsArray;
    }

    initFormArrayResponsabilities(dataBackend: any[]) {
        const itemsArray = this.fb.array([]);

        dataBackend.forEach(item => {
            itemsArray.push(this.createResponsability(item));
        });

        return itemsArray;
    }

    loadExams(): void {
        // Supongo que tienes un método que devuelve una promesa
        this.medicalExamsService.getMedicalExams().toPromise()
            .then(response => {
                this.medicalExamOptions = response.json().data;
                // Una vez que tenemos los exámenes, actualizamos el FormArray
            })
            .catch(error => {
                console.error('Error loading medical exams:', error);
            });
    }

    initializeOptions() {
        this.customerGuides = [];

        this.processTypeOptions = [
            { label: 'Estratégico', value: 'Estratégico' },
            { label: 'Misional', value: 'Misional' },
            { label: 'De apoyo', value: 'De apoyo' },
        ];

        this.dimensionsOptions = [
            { label: 'Operativa', value: 'Operativa' },
            { label: 'QHSE', value: 'QHSE' },
        ];

        this.genderOptions = [
            { label: 'Femenino', value: 'Femenino' },
            { label: 'Masculino', value: 'Masculino' },
            { label: 'Indiferente', value: 'Indiferente' },
        ];

        this.optionsSelectionCompetence = [
            { label: 'No Aplica', value: 'No Aplica' },
            { label: 'Alto', value: 'Alto' },
            { label: 'Medio', value: 'Medio' },
            { label: 'Bajo', value: 'Bajo' }
        ];

        this.optionsSelectionCompetenceSl = [
            { label: 'Alto', value: 'Alto' },
            { label: 'Medio', value: 'Medio' },
            { label: 'Bajo', value: 'Bajo' }
        ];

        this.profileSurveyLevelOptions = [
            { id: 1, label: 'Administrative', value: 'Administrativo' },
            { id: 2, label: 'Commercial', value: 'Comercial' },
            { id: 3, label: 'Strategic', value: 'Estratégico' },
            { id: 4, label: 'Operational', value: 'Operativo' },
            { id: 5, label: 'Technical', value: 'Técnico' },
        ];

        this.experienceAreaOptions = [
            { id: 1, label: 'Administrative', value: 'Administrativo' },
            { id: 2, label: 'Operational', value: 'Operativa' },
            { id: 3, label: 'Commercial', value: 'Comercial' },
            { id: 4, label: 'Financial', value: 'Financiera' },
            { id: 5, label: 'Technological', value: 'Tecnológica' },
            { id: 6, label: 'Human resources', value: 'Recursos humanos' },
            { id: 7, label: 'Legal', value: 'Legal' },
            { id: 8, label: 'Supplies', value: 'Compras' },
            { id: 9, label: 'General services', value: 'Servicios generales' },
        ];

        this.experienceSectorOptions = [
            { id: 1, label: 'Commercial', value: 'Comercial' },
            { id: 2, label: 'Services', value: 'Servicios' },
            { id: 3, label: 'Industrial', value: 'Industrial' },
            { id: 4, label: 'Real estate', value: 'Inmobiliario' },
            { id: 5, label: 'Construction', value: 'Construcción' },
            { id: 6, label: 'Agropecuarial', value: 'Agropecuario' },
            { id: 7, label: 'Public and defense', value: 'Público y defensa' },
            { id: 8, label: 'Mining and oil', value: 'Minería y petróleo' },
            { id: 9, label: 'education', value: 'Educación' },
            { id: 10, label: 'Financial', value: 'Financiera' },
            { id: 11, label: 'Health', value: 'Salud' },
            { id: 12, label: 'Mechanical metal', value: 'Metal mecánico' },
            { id: 13, label: 'other', value: 'Otro' },
        ];

        this.ARLRiskOptions = [
          { label: "Riesgo 1 (0.522)", value: 0.522 },
          { label: "Riesgo 2 (1.044)", value: 1.044 },
          { label: "Riesgo 3 (2.436)", value: 2.436 },
          { label: "Riesgo 4 (4.350)", value: 4.350 },
          { label: "Riesgo 5 (6.960)", value: 6.960 },
        ];

        this.workModeOptions = [
            { label: 'Presencial', value: 'Presencial' },
            { label: 'Teletrabajo', value: 'Teletrabajo' },
            { label: 'Mixto', value: 'Mixto' },
        ];

        this.salaryModeOptions = [
            { label: 'Ordinario', value: 'Ordinario' },
            { label: 'Integral', value: 'Integral' },
        ];

        this.salaryPaymentModeOptions = [
          { label: "Fijo Mensual", value: "Fijo Mensual" },
          { label: "Por Hora", value: "Por Hora" },
          { label: "Quincenal", value: "Quincenal" },
          { label: "Destajo", value: "Destajo" },
        ];

        this.workdayScheduleOptions = [
            { label: 'Tiempo Completo', value: 'Tiempo Completo' },
            { label: 'Medio Tiempo', value: 'Medio Tiempo' },
            { label: 'Especial', value: 'Especial' },
        ];

        this.commissionsOptions = [
            { label: 'Si', value: 1 },
            { label: 'No', value: 0 }
        ];

        this.rolesChangeEstimatedTimeRequisition = [1, 2, 25];

        this.userRole = this.getRoleId();
    }

    public getRoleId() {
        var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
        return role;
    }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/profile-surveis/new-profile-survey/new-profile-survey.component.ts